import { createLucideIcon } from 'lucide-react';

const point = (cx: string, cy: string) => ({
  cx,
  cy,
  r: '1.05',
  fill: 'currentColor',
  stroke: 'none',
  key: `${cx}-${cy}`,
});

/** Measurement surface: a plane in perspective with a grid of measurement points on it. */
const SurfacesIcon = createLucideIcon('SurfacesIcon', [
  ['path', { d: 'M2.5 18 7.5 6h14l-5 12Z', key: 'plane' }],
  ['circle', point('9.6', '10')],
  ['circle', point('13.1', '10')],
  ['circle', point('16.6', '10')],
  ['circle', point('7.9', '14')],
  ['circle', point('11.4', '14')],
  ['circle', point('14.9', '14')],
]);

export default SurfacesIcon;
